var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentWithHeader", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-between align-items-center"
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn no-bg",
                    on: {
                      click: function($event) {
                        return _vm.setPosSection("choose-product")
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-chevron-left" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [_c("TotalPriceText", { staticClass: "total-price-text" })],
                  1
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("section", { staticClass: "payment-section" }, [
              _vm.posSettings.payment.is_active
                ? _c("div", { staticClass: "wrapper-payment-methods" }, [
                    _c("div", { staticClass: "col no-padding mb-2 title" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("apps.pos.message.paymentmethod")) +
                          ":\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "btn-group btn-group-payment-methods",
                          attrs: { role: "group" }
                        },
                        _vm._l(_vm.paymentMethodsButtons, function(
                          item,
                          index
                        ) {
                          return _c(
                            "button",
                            {
                              key: index,
                              class: item.btnClass,
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.handleSelectPaymentMethod(
                                    item.name
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.text) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wrapper-payment-form" },
                [
                  _vm.paymentMethod === _vm.POS_PAYMENT_METHOD.CASH
                    ? _c("calculator-view", {
                        attrs: {
                          compare: true,
                          disabled: _vm.disabledBtnEnter
                        },
                        on: { submit: _vm.onSubmit }
                      })
                    : _c("other-payment-form", {
                        attrs: {
                          total: _vm.totalPrice,
                          paymentMethod: _vm.paymentMethod,
                          disabled: _vm.disabledBtnEnter
                        },
                        on: { submit: _vm.onSubmit }
                      })
                ],
                1
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0c04ddc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0c04ddc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/include/Payment.vue
// module id = null
// module chunks = 